var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-box",style:({ '--color': _vm.backgroundColor })},[_c('p',{staticClass:"aisea-text-14-600-pure-white"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }